import { Navigate, Outlet } from 'react-router-dom';

import { useAuth } from '../hooks/useAuth';

export const ProtectedRoutes = () => {
	const auth = useAuth();

	return auth.token.access_token !== undefined ? <Outlet /> : <Navigate to="/login" />;
};
